// ============================================================
// SwitchBank - the cockpit's protocol switches (v8.230.0).
//
// Hatred / Re-roll Dmg / Frenzied as a row of mil-spec rocker
// switches with status lamps, replacing the bare checkboxes.
// Each switch is a real `role="switch"` button (aria-checked is
// the state); the rules text rides the title exactly as the
// checkboxes carried it. Purely presentational - state lives
// with the caller.
// ============================================================
import styles from '../../styles/SwitchBank.module.css';
import clsx from '../../utils/clsx';

export interface SwitchSpec {
  key: string;
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Rules tooltip, talent notes included. */
  title: string;
  /** Lamp colour when armed. Frenzied burns red - it costs reactions. */
  lamp: 'amber' | 'red';
}

interface Props {
  switches: SwitchSpec[];
}

export default function SwitchBank({ switches }: Props) {
  return (
    <div className={styles.bank} data-testid="switch-bank">
      {switches.map((sw) => (
        <button
          key={sw.key}
          type="button"
          role="switch"
          aria-checked={sw.checked}
          title={sw.title}
          className={clsx(styles.sw, sw.checked && styles.on)}
          onClick={() => sw.onChange(!sw.checked)}
        >
          <span
            className={clsx(styles.lamp, sw.checked && (sw.lamp === 'red' ? styles.lampRed : styles.lampAmber))}
            aria-hidden="true"
          />
          <span className={styles.rocker} aria-hidden="true">
            <span className={styles.knob} />
          </span>
          <span className={styles.label}>{sw.label}</span>
        </button>
      ))}
    </div>
  );
}
